import { watchGetRecommendApps } from './sagas/watchGetRecommendApps';
import { watchGetVedaBlogs } from './sagas/watchGetVedaBlogs';

export const sagaRecommendApps = [watchGetRecommendApps, watchGetVedaBlogs];
